import React from 'react';

/** Paginado simple: « ‹ 1 2 … N › » con el rango visible. */
export default function Paginador({ pagina, totalPaginas, total, desde, hasta, onChange, etiqueta = 'tickets' }) {
    if (totalPaginas <= 1) return null;
    const paginas = [];
    const ventana = new Set([1, totalPaginas, pagina - 1, pagina, pagina + 1]);
    let previo = 0;
    for (let p = 1; p <= totalPaginas; p++) {
        if (!ventana.has(p)) continue;
        if (p - previo > 1) paginas.push('…' + p);
        paginas.push(p);
        previo = p;
    }
    const base = 'min-w-[2rem] h-8 px-2 rounded-lg text-xs font-semibold border transition-colors';
    const inactivo = 'border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-40 disabled:cursor-not-allowed';
    return (
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-2">
            <p className="text-xs text-gray-500 dark:text-gray-400">Mostrando <b>{desde}–{hasta}</b> de <b>{total}</b> {etiqueta}</p>
            <div className="flex items-center gap-1">
                <button type="button" className={`${base} ${inactivo}`} disabled={pagina === 1} onClick={() => onChange(1)} aria-label="Primera página">«</button>
                <button type="button" className={`${base} ${inactivo}`} disabled={pagina === 1} onClick={() => onChange(pagina - 1)} aria-label="Anterior">‹</button>
                {paginas.map((p) => typeof p === 'string'
                    ? <span key={p} className="px-1 text-gray-400">…</span>
                    : (
                        <button key={p} type="button" onClick={() => onChange(p)} aria-current={p === pagina ? 'page' : undefined}
                            className={`${base} ${p === pagina ? 'bg-blue-600 border-blue-600 text-white' : inactivo}`}>{p}</button>
                    ))}
                <button type="button" className={`${base} ${inactivo}`} disabled={pagina === totalPaginas} onClick={() => onChange(pagina + 1)} aria-label="Siguiente">›</button>
                <button type="button" className={`${base} ${inactivo}`} disabled={pagina === totalPaginas} onClick={() => onChange(totalPaginas)} aria-label="Última página">»</button>
            </div>
        </div>
    );
}
